import IcSale from './IcSale'
export default IcSale
